import handleSendMessage from "./handleSendMessage";

export const requestPayment = async (amount, description, chatSession, setAlert, socket, setIsModalOpen, userInfo, setAlertModalText, setAlertModalLink, setIsAlertModalOpen) =>{
    console.log("Requesting payment for chat session:", chatSession);
    console.log("Amount:", amount);
    console.log("Description:", description);
    if (!amount || isNaN(amount) || amount <= 0) {
        setAlert( 'Please provide a valid amount. We suggest you make this the total cost of the project. Exclude any currency symbols or decimal points.');
        return;
    }
    if (!description || description.trim() === '') {
        setAlert('Please provide a short, clear description. This will appear at the top of the Stripe payment page, so make sure it helps your client understand exactly what they’re paying for.');
        return;
    }

    // check user has a stripe account with payment enabled
    try {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
    const response = await fetch(`${API_BASE_URL}/api/chat/checkStripePaymentsEnabled`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-SECRET': process.env.REACT_APP_NXTVID_API_SECRET,
      },
      body: JSON.stringify({ userId: userInfo._id}),
    });

    if (!response.ok) {
      setAlert('Error creating payment request. Please try again later.');
    }

    const data = await response.json();
    if (data.paymentsEnabled) {
      console.log('Payments enabled for user:', userInfo._id);
    } else {
      if(data.hasAccount) {setAlertModalText('Before you can request payment, you need to enable payments in your account settings. This is a one-time setup that allows you to receive payments from clients.');}
      else {setAlertModalText('Before you can request payment, you need to set up your Stripe account. This is a one-time setup that allows you to receive payments from clients.');}
    
    // create the stripe account or create link with existing account
    try {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
    const response = await fetch(`${API_BASE_URL}/api/chat/createStripeAccount`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-SECRET': process.env.REACT_APP_NXTVID_API_SECRET,
      },
      body: JSON.stringify({ userId: userInfo._id}),
    });
    if (!response.ok) {
      setAlert('Error creating payment request. Please try again later.');
    }
    const data = await response.json();
    if (data.url) {
      setAlertModalLink(data.url);
      setIsAlertModalOpen(true);
      return;
    } else {
      setAlert('Error creating payment request. Please try again later.');
    }
  } catch (error) {
    setAlert('Error creating payment request. Please try again later.');
    return;  
  }
      
    }
  } catch (error) {
    setAlert('Error creating payment request. Please try again later.');
    return;
  }

  //create the check out
    try {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
    const response = await fetch(`${API_BASE_URL}/api/chat/createCheckout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-SECRET': process.env.REACT_APP_NXTVID_API_SECRET,
      },
      body: JSON.stringify({ amount, description:`Payment Request From ${chatSession.videographerName}: ${description}`, chatSession}),
    });

    if (!response.ok) {
      setAlert('Error creating payment request. Please try again later.');
    }

    const data = await response.json();
    handleSendMessage(
        socket, 
        {
            sessionId: chatSession._id,
            fromUserId: chatSession.videographerId,
            fromRole: 'system',
            content: `${chatSession.videographerName.split(' ')[0]} is requesting payment of $${amount} for:\n\n ${description}`,
            attachments: [],
            buttonText:'Pay Now',
            buttonUrl: data.url
        }
    )
    setIsModalOpen(false);
  } catch (error) {
    setAlert('Error creating payment request. Please try again later.');
  }
    
}